import { render, staticRenderFns } from "./properties-panel.vue?vue&type=template&id=9e1928b2&scoped=true&"
import script from "./properties-panel.vue?vue&type=script&lang=js&"
export * from "./properties-panel.vue?vue&type=script&lang=js&"
import style0 from "./properties-panel.vue?vue&type=style&index=0&id=9e1928b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1928b2",
  null
  
)

export default component.exports